import { LinkedinFilled, GithubFilled, MailOutlined } from "@ant-design/icons";
// import avatar from '../assets/images/peep-4.png';


export function Hero() {
    return (
        <div className="flex flex-col lg:flex-row h-[90vh] pt-[46px] text-red-600 bg-white shadow-lg justify-center items-center space-x-10 px-6">
            <div id="hero" className="flex flex-col justify-center items-start max-lg:w-11/12">
                <h2 className="text-2xl font-dmsans text-red-400">Welcome to my <span className="text-red-600 font-semibold">software engineering</span> portfolio!</h2>
                <h1 className="text-6xl lg:text-9xl font-bold font-dmsans italic py-6">Chau Nguyen</h1>

                <div className="flex flex-row justify-center space-x-8">
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://www.linkedin.com/in/chaunguyen844/" target="_blank" rel="noopener noreferrer">
                        <LinkedinFilled style={{ fontSize: '25px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://github.com/chaung844" target="_blank" rel="noopener noreferrer">
                        <GithubFilled style={{ fontSize: '25px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="mailto:nguye2cu@mail.uc.edu">
                        <MailOutlined style={{ fontSize: '25px' }}/>
                    </a>
                </div>
                
                <h2 className="text-xl font-dmsans pt-20 pb-6 text-gray-800 self-end">Let's explore the world of <span className="text-red-600 font-semibold">innovative code</span> and <span className="text-red-600 font-semibold">creative solutions</span>!</h2>
                <a href="#about" className="text-lg font-dmsan bg-gray-200 text-gray-800 hover:text-red-600 hover:scale-[1.02] px-4 py-2 self-end rounded-full shadow-lg hover:bg-gray-100">SCROLL DOWN</a>
            </div>
            {/* <div className="flex flex-col">
                <img src={avatar} alt="avatar" className="w-[250px]"/>
                <div className="flex flex-row justify-center space-x-8">
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://www.linkedin.com/in/chaunguyen844/" target="_blank" rel="noopener noreferrer">
                        <LinkedinFilled style={{ fontSize: '25px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://github.com/chaung844" target="_blank" rel="noopener noreferrer">
                        <GithubFilled style={{ fontSize: '25px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="mailto:nguye2cu@mail.uc.edu">
                        <MailOutlined style={{ fontSize: '25px' }}/>
                    </a>
                </div>
            </div> */}
        </div>

    )
}